<template>
  <div class="examIsValid">
    <div class="exam-IsValid-box">
      <div class="exam-IsValid-top">
          <div :style="{height:statusBarHeight+'px',background:'#fff'}"></div>
        <van-nav-bar title="考试结果" left-arrow @click-left="$router.push({
              name: 'examlistDetails',
              query: {
                    trainItemExamId: resultsobj.examId,
                    trainId: $route.query.businessId, 
                    type: $route.query.businessType,
                    backType: $route.query.backType}
          })" />
      </div>
      <div v-if="isfacedialog && resultsobj">
          <facedialog 
            :trainItemExamId="trainItemExamId" 
            :businessType="businessType" 
            :examId="resultsobj.examId" 
            :businessId="businessId"
            @close="close"></facedialog>
      </div>
      <div class="exam-IsValid-bgbox">
          <div class="exam-IsValid-bg">
              <div class="exam-IsValid-content1">
                  <!--交卷违规列表-->
                  <div class="exam-error-box" v-if="!resultsobj.isValid">
                      <p class="exam-error-ico"><img src="../../../assets/images/exam/error@2x.png" /></p>
                      <p class="exam-error-tips">检测到您有异常行为</p>
                  </div>
                  <!--公共引入部分-->
                  <div class="exam-IsValid-title">
                      <p class="title">{{resultsobj.examName}}
                      </p>
                      <p class="examtime">考试时间：<span>{{resultsobj.examStartTime}}</span></p>
                      <p class="examtime">考试用时：<span>{{resultsobj.useDuration}}</span></p>
                  </div>
                  <!--交卷完成列表-->
                  
                  <!--交卷违规列表-->
                  <div class="exam-error-ulbox" v-if="!resultsobj.isValid">
                      <ul>
                          <li>
                              <p>{{resultsobj.totalCount}}</p>
                              <span>总题数</span>
                          </li>
                          <li>
                              <p>{{resultsobj.totalScore}}</p>
                              <span>总分数</span>
                          </li>
                      </ul>
                  </div>
              </div>
              <!--交卷违规提示-->
              <div class="exam-result-recordBox" v-if="!resultsobj.isValid">
                  <div class="exam-result-record">
                      <p class="exam-result-test">处理结果</p>
                      <p class="exam-test-tips">本次考试成绩无效</p>
                      <p class="exam-result-test">异常记录</p>
                      <p class="exam-test-tips1">{{resultsobj.exceptionTime}}</p>
                      <p class="exam-test-tips2">{{invalidTypetext}}</p>
                  </div>
                    <div class="exam-msg-btn" @click="examInfoUrl">查看试卷详情
                        <img src="../../../assets/images/exam/right@2x.png" alt="">
                    </div>
              </div>
          </div>
      </div>
      <!--考试查看列表-->
      <div class="exam-IsValid-fotter">
          <button :class="resultsobj.yetExamCount === resultsobj.examCount ? 'btn-lowheight' : 'btn-heightlight'"  @click="exampath">{{btntext}}</button>
          <p v-if="resultsobj.examCount">（已考{{resultsobj.yetExamCount}}次/共{{resultsobj.examCount}}次）</p>
          <div :style="{height:bottomSafeHeight+'px'}"></div>
      </div>
    </div>
</div>
</template>

<script>
    import facedialog from '../../../layout/facedialog.vue';
    export default {
        name: "examIsValid",
        components: {
            facedialog,
        },
        data() {
            return {
                btntext: '',
                resultsobj: {},
                resultsId: '',
                trainItemExamId: '',
                resulType:'',
                businessType:null,
                businessId:null,
                isfacedialog: false,
                examId:null,
                invalidTypetext: '', 
                stopClickLogin: false,
                statusBarHeight:0,
                bottomSafeHeight:0           
            };
        },
        filters: {

        },
        created() {
            this.resultsId = this.$route.query.id || this.$route.query.userPaperId;
            this.trainItemExamId = Number(this.$route.query.trainItemExamId);
            this.resulType = this.$route.query.type;
            this.businessType= Number(this.$route.query.businessType);
            this.businessId=Number(this.$route.query.businessId);
            this.findUserPaperSurface();
        },
        mounted() {
            if (window.history && window.history.pushState) {
                // 往历史记录里面添加一条新的当前页面的url
                history.pushState(null, null, document.URL);
                // 给 popstate 绑定一个方法 监听页面刷新
                window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
            }
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = localStorage.getItem("statusBarHeight");
                this.bottomSafeHeight = localStorage.getItem("bottomSafeHeight");
            }
        },
        destroyed(){
            window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
        },
        methods: {
            backChange(){
                this.$router.push({
                    path: '/examlistDetails',
                    query: {
                        trainId: this.$route.query.businessId,
                        contentId: this.resultsobj.examId,
                        type: this.$route.query.businessType,
                        backType: this.$route.query.backType,
                    },
                })
            },
            examInfoUrl(){
                this.$router.push({
                    path: "/examTaking",
                    query: {
                        userPaperId: this.resultsId,
                        examId:this.resultsobj.examId,
                        businessType: this.businessType,
                        businessId:this.businessId,
                        trainItemExamId:this.trainItemExamId,
                        type: this.$route.query.type==='historical'?'historical':'examInfo',
                        backType: this.$route.query.backType,
                    }
                })
            },
            close(val) {
                this.isfacedialog = val
            },
             isDuringDate (beginDateStr, endDateStr) {
                var curDate = new Date(),
                    beginDate = new Date(beginDateStr.replace(/-/g, "/")),
                    endDate = new Date(endDateStr.replace(/-/g, "/"));
                if (curDate >= beginDate && curDate <= endDate) {
                    return true;
                }
                return false;
            },
            exampath() {
                if(this.stopClickLogin){
                   return false
                }
                this.stopClickLogin=true
               setTimeout(()=>{
                  this.stopClickLogin=false
               },5000)  
                if(this.resultsobj.yetExamCount !== this.resultsobj.examCount){
                   
                    let istime = this.resultsobj.isLimitTime ? this.isDuringDate(this.resultsobj.trainExamStartTime,this.resultsobj.trainExamEndTime) : true;
                    if(istime){
                        if(this.resultsobj.isFaceRecogBeforeExam ==0){
                            this.$router.push({
                                path: "/reading",
                                query: {
                                    userPaperId: this.resultsId,
                                    examId:this.resultsobj.examId,
                                    businessType: this.businessType,
                                    businessId:this.businessId,
                                    trainItemExamId:this.trainItemExamId,
                                    backType: this.$route.query.backType,
                                }
                            })
                        }else{
                            this.isfacedialog = true;
                        }
                    }else{
                        this.$dialog.confirm({
                        title: '提示',
                        message: '不在考试范围内',
                        })
                        .then(() => {
                            // on confirm
                        })
                        .catch(() => {
                            // on cancel
                        });
                    }
                }
            },
            findUserPaperSurface() {
                let params = {
                    userPaperId: this.resultsId,
                }
                this.$api.exam.findUserPaperSurface(
                    params
                ).then(async data => {
                    data.data.useDuration = this.timeFormatter(data.data.useDuration);
                    this.resultsobj = data.data;
                    localStorage.setItem('isFaceRecogCommitExam', this.resultsobj.isFaceRecogCommitExam);
                    localStorage.setItem('isFaceRecogDuringExam', this.resultsobj.isFaceRecogDuringExam);
                    this.btntext = this.resultsobj.yetExamCount === this.resultsobj.examCount ? '考试机会已用完' : '重考';
                    this.invalidTypetext = this.resultsobj.invalidType === 2 ? `考试过程中切换屏幕离开考场超过${this.resultsobj.switchScreenNum}次` : '未完成试卷提交前人脸验证';
                    let main = document.querySelector('.exam-IsValid-bgbox');
                    const h = window.innerHeight * 0.13;
                    main.style.paddingBottom = h + 'px';
                    // await this.getExamFace();
                })
            },
            timeFormatter(time) {
                const hours = Math.floor(time / 60 / 60);
                const minutes = Math.floor((time / 60) % 60);
                const seconds = Math.floor(time % 60);
                var hours1 = hours < 10 ? "0" + hours : hours;
                var minutes1 = minutes < 10 ? "0" + minutes : minutes;
                var seconds1 = seconds < 10 ? "0" + seconds : seconds;
                return hours1 + "时" + minutes1 + "分" + seconds1 + "秒";
            }
        },

    }
</script>
<style>
    .exam-IsValid-box .van-nav-bar__title {
        color: #ffffff !important;
    }
    .exam-IsValid-box .van-nav-bar .van-icon {
        color: #ffffff !important;
    }
    .exam-IsValid-box .van-hairline--bottom::after {
        border-bottom-width: 0px;
    }
    .exam-IsValid-box .van-nav-bar__content{
        background: #426EF7 !important;
    }
</style>
<style lang='less' scoped>
@import '../asset/css/examIsValid.less';
</style>